import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Heading, Button, useToast, HStack, Badge } from "@chakra-ui/react";
import GRLCPlacementEditorRefactored from "./GRLCPlacementEditorRefactored";
import Navbar from "./Navbar";
import { getDeal } from "./services/MrcaiAPI";

const GRLCPlacementEditorPageRefactored = () => {
  const { productCode, dealId } = useParams();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        setDeal(await getDeal(dealId));
      } catch (err) {
        toast({ title: "Failed to load deal", description: err.message, status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchDeal();
  }, [productCode, dealId, toast]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

      {/* Version indicator and switch */}
      <Box p={4} bg="blue.50" borderBottom="1px" borderColor="blue.200">
        <HStack justify="space-between">
          <HStack>
            <Badge colorScheme="blue" fontSize="md" px={3} py={1}>
              Refactored Version
            </Badge>
            <Heading size="sm" color="blue.700">
              50% less code • Modular architecture • Same functionality
            </Heading>
          </HStack>
          <Button
            size="sm"
            colorScheme="gray"
            onClick={() => navigate(`/product/${productCode}/deal/${dealId}/placement`)}
          >
            Switch to Original Version
          </Button>
        </HStack>
      </Box>

      {/* Deals no longer carry placement terms: editable but not saveable */}
      <GRLCPlacementEditorRefactored contractInstance={deal} productTemplate={null} recordType="deal" />
    </Box>
  );
};

export default GRLCPlacementEditorPageRefactored;
